
import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Container, Grid, Link } from '@mui/material'
import { withStyles } from '@mui/styles';

import { MIN_AMOUNT } from 'utils/contants'
import { ExpandMore } from '@mui/icons-material';

const MuiAccordion = withStyles({
  root: {
    '&::before': {
      backgroundColor: '#ECECED',
      marginTop: '-4px'
    },
  },
})(Accordion)


const MuiAccordionSummary = withStyles({
  root: {
    borderRightWidth: 0,
    borderLeftWidth: 0,
    margin: 0,
    marginTop: '8px',
    padding: '12px 4px',
    '&::before': {
      backgroundColor: '#ECECED',
      marginTop: '-4px'
    },
  },
  expanded: {
    minHeight: '30px !important',
  },
  content: {
    margin: 0,
    '&$expanded': {
      margin: '0',
      padding: '0'
    },
  },
  expandIcon: {
    marginRight: 0,
    paddingTop: 0
  }
})(AccordionSummary)

const MuiAccordionDetails = withStyles({
  root: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})(AccordionDetails)


const doubt = [
  {
    title: '¿Qué es un Préstamo Digital?  ',
    content: (<span>
      Es un préstamo de consumo otorgado para la compra de bienes, servicios o gastos no relacionados con una actividad productiva o comercial, que puedes
      <Link
        className='bp-mx-4'
        target="_blank"
        href={'https://creditoenlinea.pichincha.com/autogestion/login/?utm_source=portal&utm_medium=referral&utm_campaign=preciso&utm_content=btn_catalogo_tcredito_preciso'}
        id-element="link-exit"
      >
        solicitarlo en línea
      </Link>
      o en tu agencia más cercana.
    </span>)
  },
  {
    title: '¿Debo ser cliente de Banco Pichincha para solicitar un Préstamo Digital?',
    content: (<span>
      Si. Necesitas ser cliente y mantener una cuenta bancaria activa en Banco Pichincha para que el monto del préstamo
      pueda ser acreditado. Si no tienes una cuenta puedes solicitarla
      <Link
        className='bp-mx-4'
        target="_blank"
        href={`${process.env.REACT_APP_URL_ACCOUNT_SIMPLE}`}
      > aquí. </Link>
    </span>)
  },
  {
    content: `Para un Préstamo Digital puedes solicitar un monto desde $${MIN_AMOUNT} hasta $40.000, sin la necesidad de firmar documentos y previa evaluación crediticia. El monto de crédito dependerá de tu capacidad de pago mensual. `,
    title:
      '¿Cuál es el monto mínimo y máximo que puedo solicitar para mi Préstamo Digital?'
  },
  {
    content: 'Puedes elegir un plazo entre 3 y 60 meses para pagar tu préstamo, dependiendo de tu capacidad de pago mensual.',
    title: '¿A qué plazo puedo solicitar mi Préstamo Digital?'
  },
  {
    content: 'No. Banco Pichincha no solicita tu ingreso a la Banca móvil o web para solicitar un Préstamo Digital, siempre y cuando tengas un correo electrónico y número de celular registrado. En caso de dudas puedes contactarte a nuestro call center (02) 2999 999.',
    title: '¿Necesito ingresar a Banca móvil o Banca web para acceder al Préstamo Digital?'
  },
  {
    content: 'Si necesitas condiciones diferentes a las presentadas, por favor acércate a agencia.',
    title: '¿Qué hago si necesito otro sistema de amortización para mi Préstamo Digital?'
  }
]

const Doubt: React.FC = () => {
  return (
    <div className="bp-pb-12 background ">
      <Container>
        <Grid container >
          <Grid className="bp-my-32" item xs={12} >
            <pichincha-typography variant="h2" align="center" color='darkGrey' weight_color='500'>
              ¿Tienes dudas?
            </pichincha-typography>
          </Grid>
          <Grid item xs={12} className="bp-mx-64 size-list">
            {doubt.map((a, index) => (
              <MuiAccordion key={index} className="background">
                <MuiAccordionSummary
                  className="background"
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id={`panel1a-header-${index}`}
                >
                  <pichincha-typography className="" color='black' variant='h6'>
                    {a.title}
                  </pichincha-typography>
                </MuiAccordionSummary>
                <MuiAccordionDetails>
                  <pichincha-typography>
                    {a.content}
                  </pichincha-typography>
                </MuiAccordionDetails>
              </MuiAccordion>
            ))}
          </Grid>
        </Grid>
      </Container >
    </div>
  )
}

export default Doubt